/**
 * INTERVIEW FILTER
 */
;(function () {
  'use strict'

  const filterButtons = document.querySelectorAll('.js-filter-btn')
  const filterSelects = document.querySelectorAll('.js-filter-select')
  const interviewItems = document.querySelectorAll('.js-interview-item')
  const noResults = document.querySelector('.secInterviewList__no-results')

  if (!filterButtons.length || !interviewItems.length) {
    return
  }

  // Filter state
  let filters = {
    job: 'all',
    brand: 'all',
    graduate: 'all',
  }

  filterButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const filterType = this.dataset.filterType
      const filterValue = this.dataset.filterValue

      // 同じグループの他のボタンからactiveを削除
      const buttonGroup = this.closest('.secFilter__group')
      const groupButtons = buttonGroup.querySelectorAll('.js-filter-btn')
      groupButtons.forEach((btn) => {
        btn.classList.remove('active')
      })

      // Add active to clicked button
      this.classList.add('active')

      // Selectbox
      const groupSelect = buttonGroup.querySelector('.js-filter-select')
      if (groupSelect) {
        groupSelect.value = filterValue
      }

      // Update filter state
      filters[filterType] = filterValue

      // Apply filters
      applyFilters()
    })
  })

  // select
  filterSelects.forEach((select) => {
    select.addEventListener('change', function () {
      const filterGroup = this.closest('.secFilter__group')
      const firstButton = filterGroup.querySelector('.js-filter-btn')

      if (!firstButton) {
        return
      }

      const filterType = firstButton.dataset.filterType
      const filterValue = this.value

      // button
      const groupButtons = filterGroup.querySelectorAll('.js-filter-btn')
      groupButtons.forEach((btn) => {
        btn.classList.remove('active')
        if (btn.dataset.filterValue === filterValue) {
          btn.classList.add('active')
        }
      })

      // Update filter state
      filters[filterType] = filterValue

      // Apply filters
      applyFilters()
    })
  })

  /**
   * Apply filters
   */
  function applyFilters() {
    let visibleCount = 0

    interviewItems.forEach((item) => {
      const itemJob = item.dataset.job
      const itemBrand = item.dataset.brand
      const itemGraduate = (item.dataset.graduate || '').trim().split(/\s+/)

      const jobMatch = filters.job === 'all' || itemJob === filters.job
      const brandMatch = filters.brand === 'all' || itemBrand === filters.brand
      const graduateMatch = filters.graduate === 'all' || (itemGraduate.length && itemGraduate.includes(filters.graduate))

      if (jobMatch && brandMatch && graduateMatch) {
        item.classList.remove('is-hidden')
        visibleCount++
      } else {
        item.classList.add('is-hidden')
      }
    })

    if (visibleCount === 0) {
      if (noResults) {
        noResults.classList.add('is-visible')
        noResults.style.display = 'block'
      }
    } else {
      if (noResults) {
        noResults.classList.remove('is-visible')
        noResults.style.display = 'none'
      }
    }
  }

  applyFilters()
})()

/**
 * INTERVIEW MODAL
 */
;(function () {
  'use strict'

  const interviewLinks = document.querySelectorAll('.js-interview-link')
  const modalContent = document.querySelector('.js-interview-modal-content')

  if (!interviewLinks.length || !modalContent) {
    return
  }

  interviewLinks.forEach((link) => {
    link.addEventListener('click', function (e) {
      e.preventDefault()

      const interviewUrl = this.dataset.interviewUrl
      if (!interviewUrl) {
        return
      }

      // LOADING DISPLAY
      modalContent.innerHTML = '<div style="padding: 2rem; text-align: center;">読み込み中...</div>'

      // OPEN MODAL
      if (window.modalOpen) {
        window.modalOpen('interviewModal')
      }

      // AJAX LOAD INTERVIEW
      fetch(interviewUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.text()
        })
        .then((html) => {
          // HTMLから必要な部分を抽出
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          const bodyWithInterview = doc.querySelector('body.interview-single')
          const scripts = doc.querySelectorAll('script')

          let contentHTML = ''

          if (bodyWithInterview) {
            // body.b-interviewの完全な内容を取得
            contentHTML = bodyWithInterview.innerHTML
          } else {
            // フォールバック: 個別の要素を取得
            const header = doc.querySelector('header#header')
            const gNav = doc.querySelector('#gNav')
            const interviewSection = doc.querySelector('.singlePV')
            const footer = doc.querySelector('footer#footer')

            if (header && interviewSection && footer) {
              // Full content with gNav
              let headerHTML = header.outerHTML
              // gNavがheader内にない場合は追加
              if (gNav && !header.querySelector('#gNav')) {
                headerHTML += gNav.outerHTML
              }
              contentHTML = headerHTML + interviewSection.outerHTML + footer.outerHTML
            } else if (interviewSection) {
              // interview content with gNav if available
              contentHTML = interviewSection.outerHTML
              if (gNav) {
                contentHTML = gNav.outerHTML + contentHTML
              }
            } else {
              modalContent.innerHTML =
                '<div style="padding: 2rem; text-align: center;">インタビューが見つかりませんでした。</div>'
              return
            }
          }

          // HTMLを挿入
          modalContent.innerHTML = contentHTML

          // JavaScriptを実行
          if (scripts.length > 0) {
            scripts.forEach((script) => {
              const newScript = document.createElement('script')

              // src属性がある場合はそのままコピー
              if (script.src) {
                newScript.src = script.src
              } else {
                // インラインスクリプトの場合は内容をコピー
                newScript.textContent = script.textContent
              }

              // type属性がある場合はコピー
              if (script.type) {
                newScript.type = script.type
              }

              // モーダルコンテンツに追加して実行
              modalContent.appendChild(newScript)
            })
          }
        })
        .catch((error) => {
          console.error('Error loading interview:', error)
          modalContent.innerHTML = '<div style="padding: 2rem; text-align: center;">読み込みに失敗しました。</div>'
        })
    })
  })
})()

//モーダル内のgNav-openをクリックした時の処理
if (document.querySelector('#interview-single')) {
  document.querySelector('#interview-single').addEventListener('click', function () {
    const html = document.documentElement

    html.style.overflow = 'hidden'
    html.style.scrollbarGutter = 'stable'

    if (!this.classList.contains('active')) {
      this.classList.add('active')
      this.closest('.js-modal').querySelector('#overlay').classList.add('active')
      this.closest('.js-modal').querySelector('#gNav').classList.add('active')
      this.closest('.js-modal').querySelector('#gNav').style.display = 'block'
    } else {
      this.classList.remove('active')
      this.closest('.js-modal').querySelector('#overlay').classList.remove('active')
      this.closest('.js-modal').querySelector('#gNav').classList.remove('active')
      this.closest('.js-modal').querySelector('#gNav').style.display = 'none'
    }
  })
}

if (document.querySelector('.js-modal-close--interview')) {
  document.querySelector('.js-modal-close--interview').addEventListener('click', () => {
    location.reload()
  })
}
